const angular = require('angular')
const authenticator = require('./authenticator')
const WmsvrClient = require('./WmsvrClient')
const IndexedDB = require('./IndexedDB')
const JSBridge = require('./JSBridge')
const DomUtils = require('./DomUtils')
const Promise = require('./Promise')
const LocalStorage = require('./LocalStorage')
require('./helpers')
require('./Array')
require('./transition')
require('./message')
require('./loading')
require('./section')
require('./contact')
require('./onerror')

const components = angular.module('hxphone.infrastructure', [
  'ui.hxphone.helpers',
  'ui.hxphone.transition',
  'ui.hxphone.message',
  'ui.hxphone.loading',
  'ui.hxphone.section',
  'hxphone.infrastructure.contact',
  'hxphone.utils',
  'ui.hxphone.onerror'
])

components.factory('Authenticator', authenticator)

  .service('WmsvrClient', WmsvrClient)

  .factory('DomUtils', DomUtils)

  .factory('Promise', Promise)

  .service('LocalStorage', LocalStorage)

  .service('IndexedDB', IndexedDB)

  .service('JSBridge', JSBridge)
module.exports = components



// WEBPACK FOOTER //
// ./src/js/infrastructure/module.js